"use client";

import type { ComponentPropsWithRef } from "react";
import { cn } from "@/services/styles/cn";
import styles from "./input.module.css";
import type { InputWrapperWrap } from "./input-wrapper";
import { InputWrapper } from "./input-wrapper";

export interface InputProps extends ComponentPropsWithRef<"input"> {
  wrap?: InputWrapperWrap;
}

export function Input({ className, wrap = true, ...props }: InputProps) {
  const inputElement = <input className={cn(styles.input, className)} {...props} />;

  return wrap ? <InputWrapper wrap={wrap}>{inputElement}</InputWrapper> : inputElement;
}
